import styled from '@emotion/styled';
import { css, type Theme } from '@emotion/react';

import type { ReactNode } from 'react';
import type { SerializedStyles } from '@emotion/serialize';

export type BoxStylingProps = {
  mb?: keyof Theme['spacings'];
  mt?: keyof Theme['spacings'];
  ml?: keyof Theme['spacings'];
  mr?: keyof Theme['spacings'];
  fw?: keyof Theme['fontWeights'];
  textAlign?:
    | 'start'
    | 'end'
    | 'left'
    | 'right'
    | 'center'
    | 'justify'
    | 'justify-all'
    | 'match-parent';
  maxWidth?: string;
  display?: 'flex' | 'inline-flex' | 'inline' | 'block' | 'none';
};

export const boxStyles =
  (props: BoxStylingProps) =>
  (theme: Theme): SerializedStyles =>
    css`
      margin-bottom: ${props.mb && theme.spacing(props.mb)};
      margin-top: ${props.mt && theme.spacing(props.mt)};
      margin-left: ${props.ml && theme.spacing(props.ml)};
      margin-right: ${props.mr && theme.spacing(props.mr)};
      font-weight: ${props.fw && theme.fontWeights[props.fw]};
      text-align: ${props.textAlign};
      max-width: ${props.maxWidth};
      display: ${props.display};
    `;

export type BoxProps = BoxStylingProps & { children?: ReactNode };

export const Box = styled.div<BoxStylingProps>`
  ${({ theme, ...props }) => boxStyles(props)(theme)};
`;
